import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import DocumentTypeViewModel from '../ViewModels/DocumentTypeViewModel';
import { SelectValidator } from 'react-material-ui-form-validator';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IDocumentTypeDropDownProps {
    setDocumentType?: (event) => void;
    documentType: number | null;
    disabled: boolean;
}

interface IDocumentTypeDropDownState {
    model: DocumentTypeViewModel[];
    loaded: boolean;
}

class DocumentTypeDropDown extends Component<IDocumentTypeDropDownProps & WithStyles<typeof styles>, IDocumentTypeDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetDocumentTypes').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultDocumentTypeVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="Please select which type of document you are uploading"
                name="documentType"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.documentType}
                onChange={this.props.disabled ? undefined : this.props.setDocumentType}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(DocumentTypeDropDown);